export function getUnixTimestamp(dateString: string) {
  const date = new Date(dateString);
  const unixTimestamp = Math.floor(date.getTime() / 1000);

  return unixTimestamp;
}
